import { usePrivateIntegrationsSyncContext } from 'modules/integrations/hooks/SyncContext'
import { syncStatusFilter } from 'modules/integrations/lib/DataCollection/filters'

export const useSyncStatusFilter = () => {
  const { syncEnabled, capabilityMode, configuration } = usePrivateIntegrationsSyncContext()
  if (!syncEnabled) return null

  return syncStatusFilter(configuration, capabilityMode)
}
